



















import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { ClaimedRowInsertCaret } from './types';
import { CSSStyleOptions } from '../common-types';

const cssPrefix = 'sw-table-row-insert-caret';

@Component({
  components: {},
})
export default class SwTableRowInsertCaret extends SwExtendedVue {
  @Prop()
  info: ClaimedRowInsertCaret;

  @Prop({ type: Number })
  width: number;

  cssPrefix =  cssPrefix;
  position: { top: number; left: number; } = { top: 0, left: 0 };

  get rootStyle(): CSSStyleOptions {
    return {
      width: `${this.width}px`,
      top: `${this.position.top}px`,
      left: `${this.position.left}px`,
    };
  }

  @Watch('info')
  private updatePosition() {
    this.$nextTick(() => {
      if (!this.$el || !(this.$el as HTMLElement).offsetParent) { return; }
      if (!this.info.rowEl) { return; }
      const rect = this.info.rowEl.getBoundingClientRect();
      const opRect = (this.$el as HTMLElement).offsetParent!.getBoundingClientRect();
      const insertPos = this.info.position || 'before';
      this.position = {
        top: rect.top - opRect.top + (insertPos === 'before' ? 0 : rect.height),
        left: rect.left - opRect.left,
      };
    });
  }

  private mounted() {
    this.updatePosition();
  }
}
